import { Component, inject } from '@angular/core';
import { NxLabelModule } from '@aposin/ng-aquila/base';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  template: `<div data-testid="session-expired-modal">
    <div class="flex justify-center mb-3.5">
      <nx-icon style="color: var(--button-tertiary-text-color)" name="product-clock" aria-hidden="true" size="l" />
    </div>
    <h3 class="text-center" nxHeadline size="m">{{ 'session-expired.title' | translate }}</h3>
    <nx-label class="nx-margin-s text-center">
      {{ 'session-expired.message' | translate }}
    </nx-label>
    <div class="flex justify-center mt-7">
      <button (click)="data.reload()" nxButton="small-medium" type="button">
        {{ 'session-expired.reload' | translate }}
      </button>
    </div>
  </div>`,
  imports: [NxHeadlineModule, NxButtonModule, NxIconModule, NxLabelModule, TranslateModule],
})
export class SessionExpiredModalComponent {
  readonly data = inject<{
    reload: () => void;
  }>(NX_MODAL_DATA);
}
